import LibrariesCompounds from "./LibrariesCompounds";

export default LibrariesCompounds;